'use strict';

import PropTypes from 'prop-types';
import React from 'react';
import { trackCustomEvent } from '../../utils/statistics/clientStatistics';
import { footerClickEvent } from '../../utils/statistics/customEvents';
import ContentoQuery from '../Contento/ContentoQuery';
import Devices from '../Devices/Devices.jsx';
import ExternalIcon from '../Link/ExternalIcon.jsx';
import MAIN_GENRES_QUERY from '../PromotionGrid/MainGenres.graphql';
import { ServiceLink } from './Footer.styles';
import {
    Button,
    Buttons,
    FooterContainer,
    GenreLink,
    Genres,
    GenresList,
    GenresListElement,
    IconContainer,
    Services,
    Service,
} from './Footer.styles.js';
import { PlayContainerBase } from '../../ui-components/PlayContainer/PlayContainer.styles';
import { ButtonLabel } from '../../ui-components/PlayButton/PlayButton.styles';
import PlayText, { TYPES } from '../../ui-components/typography/PlayText/PlayText';
import { regularWhite } from '../../ui-components/design-tokens';
import ExternalTeasers from 'app/components/ExternalTeasers/ExternalTeasers';
import { useRouter } from 'next/router';

const trackClick = (name) => {
    const event = footerClickEvent(name);
    trackCustomEvent(event);
};

const FooterGenres = () => {
    return (
        <ContentoQuery query={MAIN_GENRES_QUERY}>
            {(data) => {
                const mainGenres = data.genres;

                if (!mainGenres || !mainGenres.length) {
                    return null;
                }

                const lastIndex = mainGenres.length - 1;

                return (
                    <Genres>
                        <nav>
                            <GenresList>
                                {
                                    //remove last genre cause we want to use the "Alla program" link instead
                                    mainGenres.slice(0, -1).map((item, index) => {
                                        return (
                                            <GenresListElement key={`clust-${index}`}>
                                                <PlayText type={TYPES.LARGE} color={regularWhite}>
                                                    <GenreLink
                                                        to={`/genre/${item.id}`}
                                                        onClick={() => {
                                                            trackClick(item.name);
                                                        }}
                                                    >
                                                        <span>{item.name}</span>
                                                    </GenreLink>
                                                </PlayText>
                                            </GenresListElement>
                                        );
                                    })
                                }
                                <GenresListElement key={`clust-${lastIndex}`}>
                                    <PlayText type={TYPES.LARGE} color={regularWhite}>
                                        <GenreLink
                                            className={`lp_pos${lastIndex}`}
                                            to="/program"
                                            onClick={() => {
                                                trackClick('Alla program');
                                            }}
                                        >
                                            <span>Alla program</span>
                                        </GenreLink>
                                    </PlayText>
                                </GenresListElement>
                            </GenresList>
                        </nav>
                    </Genres>
                );
            }}
        </ContentoQuery>
    );
};

const Footer = () => {
    const router = useRouter();
    const isStartpage = router.asPath === '/';

    return (
        <FooterContainer>
            <PlayContainerBase>
                {isStartpage && <ExternalTeasers />}
                <FooterGenres />
                <Devices
                    onDeviceClick={(name) => {
                        trackClick(name);
                    }}
                />
                <IconContainer>
                    <span className="play_footer__svt-logo" />
                    <PlayText type={TYPES.MINI}>Sveriges Television AB</PlayText>
                </IconContainer>
                <Buttons data-rt="footer-buttons">
                    <Button
                        to="/installningar"
                        onClick={() => {
                            trackClick('Inställningar');
                        }}
                        className="lp_pos1"
                    >
                        <span
                            className="svt_icon svt_icon--cog svt_icon--1-2x svt_icon--text-align play_button__icon"
                            aria-hidden="true"
                        />
                        <ButtonLabel>Inställningar</ButtonLabel>
                    </Button>
                    <Button
                        isExternal={true}
                        to="https://kontakt.svt.se"
                        className="lp_pos2"
                        onClick={() => {
                            trackClick('Kontakt');
                        }}
                    >
                        <ExternalIcon isExternal={true}>
                            <ButtonLabel>Kontakt</ButtonLabel>
                        </ExternalIcon>
                    </Button>
                </Buttons>
                <Services>
                    <Service data-rt="footer-element">
                        <ServiceLink
                            url="https://www.svt.se"
                            text="svt.se"
                            className="play_footer__service-link lp_pos1"
                            onClick={() => {
                                trackClick('svt.se');
                            }}
                        />
                    </Service>
                    <Service data-rt="footer-element">
                        <ServiceLink
                            url="https://nyhetsbrev.svtplay.se/prenumerera/?utm_source=svtplay&utm_medium=footer-cta"
                            text="Nyhetsbrev"
                            onClick={() => {
                                trackClick('Nyhetsbrev');
                            }}
                        />
                    </Service>
                    <Service data-rt="footer-element">
                        <ServiceLink
                            url="https://www.oppetarkiv.se"
                            text="oppetarkiv.se"
                            onClick={() => {
                                trackClick('oppetarkiv.se');
                            }}
                        />
                    </Service>
                    <Service data-rt="footer-element">
                        <ServiceLink
                            url="https://kontakt.svt.se/guide/cookies-och-personuppgifter"
                            text="Om cookies"
                            onClick={() => {
                                trackClick('Om cookies');
                            }}
                        />
                    </Service>
                </Services>
            </PlayContainerBase>
        </FooterContainer>
    );
};

Footer.propTypes = {
    content: PropTypes.object,
};

export default Footer;
